export const values = [
  {
    '#': '1',
    Library: 'abs-svg-path-0.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: '2013 Copyright (c) Jake Rosoman jkroso@gmail.com'
  },
  {
    '#': '2',
    Library: 'acorn-7.4.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 by Marijn Haverbeke (marijnh@gmail.com)'
  },
  {'#': '3', Library: 'almost-equal-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Mikola Lysenko'},
  {'#': '4', Library: 'ansi-regex-5.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright sindresorhus.com'},
  {
    '#': '5',
    Library: 'ansi-styles-4.3.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {
    '#': '6',
    Library: 'ansi-styles-5.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {
    '#': '7',
    Library: 'apollo-link-debounce-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017-2018 Jonas Helfer'
  },
  {'#': '8', Library: 'area-6.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 TurfJS'},
  {Copyrights: 'Copyright 2019 Morgan Herlocker'},
  {'#': '9', Library: 'aria-query-4.2.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '10', Library: 'aria-query-5.0.0.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2020 A11yance'},
  {Copyrights: 'Copyright 2021 A11yance'},
  {'#': '11', Library: 'array-bounds-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Dmitry Yv'},
  {
    '#': '12',
    Library: 'array-find-index-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '13', Library: 'array-normalize-1.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright Dmitry Yv'},
  {'#': '14', Library: 'array-range-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Matt DesLauriers'},
  {
    '#': '15',
    Library: 'array-rearrange-2.2.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Dmitry Ivanov "df.creative@gmail.com" (mailto:df.creative@gmail.com)'
  },
  {'#': '16', Library: 'atob-2.1.2.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2015 AJ ONeal'},
  {Copyrights: 'Copyright 2012-2018 Docs copyright'},
  {Copyrights: 'Copyright 2012-2018 ode copyright'},
  {
    '#': '17',
    Library: 'babel-plugin-11.9.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '18', Library: 'babel-plugin-macros-2.8.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Kent C'},
  {'#': '19', Library: 'base-5.0.0-beta.40.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '20',
    Library: 'base64-arraybuffer-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 Niklas von Hertzen'
  },
  {Copyrights: 'Copyright 2012 Niklas von Hertzen'},
  {Copyrights: 'Copyright 2012 Niklas von Hertzen'},
  {Copyrights: 'Copyright 2012 Niklas von Hertzen'},
  {'#': '21', Library: 'base64-js-1.5.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Jameson Little'},
  {Copyrights: 'Copyright 2014 Jameson Little'},
  {'#': '22', Library: 'batch-processor-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Lucas Wiener'},
  {'#': '23', Library: 'bbox-6.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 TurfJS'},
  {Copyrights: 'Copyright 2019 Morgan Herlocker'},
  {'#': '24', Library: 'bidi-js-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Jason Johnston'},
  {
    '#': '25',
    Library: 'binary-search-bounds-2.0.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013-2015 Mikola Lysenko'
  },
  {Copyrights: 'Copyright 2013-2015 Mikola Lysenko'},
  {'#': '26', Library: 'bit-twiddle-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Mikola Lysenko'},
  {'#': '27', Library: 'bitmap-sdf-1.0.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {'#': '28', Library: 'bl-2.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright (c) 2013-2016, Rod Vagg'},
  {'#': '29', Library: 'brotli-1.3.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright https://www.npmjs.com/~devongovett'},
  {
    '#': '30',
    Library: 'browserify-zlib-0.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2015 Devon Govett <devongovett@gmail.com>'
  },
  {'#': '31', Library: 'buffer-from-1.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016-2018 Linus Unneb'},
  {
    '#': '32',
    Library: 'cache-11.11.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {
    '#': '33',
    Library: 'callsites-3.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '34',
    Library: 'canvas-fit-1.5.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Hugh Kennedy hughskennedy@gmail.com'
  },
  {'#': '35', Library: 'centroid-6.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 TurfJS'},
  {Copyrights: 'Copyright 2019 Morgan Herlocker'},
  {
    '#': '36',
    Library: 'chalk-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {
    '#': '37',
    Library: 'chalk-4.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {'#': '38', Library: 'chart.js-4.5.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014-2024 Chart.js Contributors'},
  {
    '#': '39',
    Library: 'chartjs-plugin-annotation-3.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016-2021 chartjs'
  },
  {Copyrights: 'Copyright 2016-2021 chartjs'},
  {
    '#': '40',
    Library: 'chartjs-plugin-zoom-2.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013-2021 chartjs-plugin-zoom contributors'
  },
  {'#': '41', Library: 'clamp-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Hugh Kennedy'},
  {'#': '42', Library: 'classnames-2.3.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Jed Watson'},
  {Copyrights: 'Copyright 2018 Jed Watson'},
  {'#': '43', Library: 'client-2.2.0.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2022 MapTiler'},
  {'#': '44', Library: 'client-3.6.9.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2022 Apollo Graph, Inc'},
  {'#': '45', Library: 'clone-2.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Paul Vorbach'},
  {
    '#': '46',
    Library: 'clsx-1.2.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {
    '#': '47',
    Library: 'clsx-2.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {
    '#': '48',
    Library: 'code-frame-7.27.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '49', Library: 'color-0.3.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018-2024 Jukka Kurkela'},
  {
    '#': '50',
    Library: 'color-alpha-1.0.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Dmitry Yv dfcreative@gmail.com'
  },
  {
    '#': '51',
    Library: 'color-convert-2.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011-2016 Heather Arthur and Josh Junon'
  },
  {Copyrights: 'Copyright 2011-2016 Heather Arthur <fayearthur@gmail.com>'},
  {'#': '52', Library: 'color-id-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Dmitry Yv'},
  {'#': '53', Library: 'color-name-1.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {'#': '54', Library: 'color-name-1.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {'#': '55', Library: 'color-normalize-1.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {'#': '56', Library: 'color-parse-1.4.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {'#': '57', Library: 'color-parse-2.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {'#': '58', Library: 'color-rgba-2.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {
    '#': '59',
    Library: 'color-space-1.16.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Deema Yvanow dfcreative@gmail.com'
  },
  {
    '#': '60',
    Library: 'color-string-1.9.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011 Heather Arthur <fayearthur@gmail.com>'
  },
  {
    '#': '61',
    Library: 'commander-2.20.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {
    '#': '62',
    Library: 'commander-7.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {Copyrights: 'Copyright 2011 TJ Holowaychuk <tj@vision-media.ca>'},
  {'#': '63', Library: 'concat-stream-1.6.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Max Ogden'},
  {
    '#': '64',
    Library: 'context-0.6.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'
  },
  {Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'},
  {'#': '65', Library: 'convert-source-map-1.8.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Thorsten Lorenz'},
  {Copyrights: 'Copyright 2013 Thorsten Lorenz'},
  {'#': '66', Library: 'core-1.6.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {Copyrights: 'Copyright 2016 Federico Zivolo'},
  {Copyrights: 'Copyright 2016 Federico Zivolo and contributors'},
  {Copyrights: 'Copyright and license'},
  {'#': '67', Library: 'core-2.11.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Federico Zivolo'},
  {'#': '68', Library: 'core-3.1.1.tgz', Licenses: 'MIT', Copyrights: '2020 Copyright (c) Dotan Simha'},
  {'#': '69', Library: 'core-downloads-tracker-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '70', Library: 'core-util-is-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Node.js contributors'},
  {'#': '71', Library: 'cosmiconfig-6.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 David Clark'},
  {
    '#': '72',
    Library: 'country-regex-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 tienne Tétreault-Pinard'
  },
  {'#': '73', Library: 'cross-fetch-3.1.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Leonardo Quixadá'},
  {'#': '74', Library: 'crypto-js-4.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2009-2013 Jeff Mott'},
  {Copyrights: 'Copyright 2013-2016 Evan Vosberg'},
  {
    '#': '75',
    Library: 'css-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {'#': '76', Library: 'css-font-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {Copyrights: 'Copyright 2018 Dmitry Yv'},
  {'#': '77', Library: 'css-font-size-keywords-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {'#': '78', Library: 'css-font-stretch-keywords-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {'#': '79', Library: 'css-font-style-keywords-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {'#': '80', Library: 'css-font-weight-keywords-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {'#': '81', Library: 'css-global-keywords-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {'#': '82', Library: 'css-system-font-keywords-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jed Mao'},
  {
    '#': '83',
    Library: 'css.escape-1.5.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Mathias Bynens <https://mathiasbynens.be/>'
  },
  {Copyrights: 'Copyright Mathias Bynens <https://mathiasbynens.be/>'},
  {
    '#': '84',
    Library: 'csscolorparser-1.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 Dean McNamee dean@gmail.com'
  },
  {'#': '85', Library: 'csstype-3.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017-2018 Fredrik Nicol'},
  {'#': '86', Library: 'd-1.0.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2013-2024 Mariusz Nowak'},
  {'#': '87', Library: 'd3-3.8.2.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Michael Bostock'},
  {'#': '88', Library: 'd3-7.5.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2022 Mike Bostock'},
  {'#': '89', Library: 'd3-array-1.2.4.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '90', Library: 'd3-array-3.2.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2023 Mike Bostock'},
  {'#': '91', Library: 'd3-axis-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '92', Library: 'd3-brush-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '93', Library: 'd3-chord-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021 Mike Bostock'},
  {'#': '94', Library: 'd3-collection-1.0.7.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '95', Library: 'd3-color-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2022 Mike Bostock'},
  {'#': '96', Library: 'd3-contour-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2012-2021 Mike Bostock'},
  {'#': '97', Library: 'd3-delaunay-6.0.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021 Mapbox'},
  {Copyrights: 'Copyright 2018-2021 Observable, Inc'},
  {'#': '98', Library: 'd3-dispatch-1.0.6.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '99', Library: 'd3-dispatch-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '100', Library: 'd3-drag-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '101', Library: 'd3-dsv-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2013-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2013-2021 Mike Bostock'},
  {'#': '102', Library: 'd3-ease-3.0.1.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2001 Robert Penner'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2001 Robert Penner'},
  {'#': '103', Library: 'd3-fetch-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2016-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2016-2021 Mike Bostock'},
  {'#': '104', Library: 'd3-force-1.2.1.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '105', Library: 'd3-force-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '106', Library: 'd3-format-1.4.5.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2015 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2015 Mike Bostock'},
  {'#': '107', Library: 'd3-format-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '108', Library: 'd3-geo-1.12.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {Copyrights: 'Copyright 2008-2012 Charles Karney'},
  {Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {Copyrights: 'Copyright 2008-2012 Charles Karney'},
  {'#': '109', Library: 'd3-geo-3.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2010-2024 Mike Bostock'},
  {Copyrights: 'Copyright 2008-2012 Charles Karney'},
  {'#': '110', Library: 'd3-geo-projection-2.9.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013-2016 Mike Bostock'},
  {Copyrights: 'Copyright 2015 Ricky Reusser'},
  {'#': '111', Library: 'd3-hierarchy-1.1.9.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '112', Library: 'd3-hierarchy-3.1.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '113', Library: 'd3-interpolate-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '114', Library: 'd3-path-1.0.9.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2015-2016 Mike Bostock'},
  {'#': '115', Library: 'd3-path-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2015-2022 Mike Bostock'},
  {'#': '116', Library: 'd3-polygon-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '117', Library: 'd3-quadtree-1.0.7.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '118', Library: 'd3-quadtree-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '119', Library: 'd3-random-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '120', Library: 'd3-sankey-0.7.2.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2015 Mike Bostock'},
  {'#': '121', Library: 'd3-sankey-circular-0.33.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Tom Shanley'},
  {
    '#': '122',
    Library: 'd3-scale-4.0.2.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2024 Mike Bostock and Observable, Inc.'
  },
  {
    '#': '123',
    Library: 'd3-scale-chromatic-3.1.0.tgz',
    Licenses: 'Apache 2.0',
    Copyrights: 'Copyright 2010-2024 Mike Bostock'
  },
  {Copyrights: 'Copyright 2002 Cynthia Brewer, Mark Harrower, and The Pennsylvania State University'},
  {
    '#': '124',
    Library: 'd3-selection-3.0.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2024 Mike Bostock and Observable, Inc.'
  },
  {'#': '125', Library: 'd3-shape-1.3.7.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2015 Mike Bostock'},
  {'#': '126', Library: 'd3-shape-3.2.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2022 Mike Bostock'},
  {'#': '127', Library: 'd3-time-1.1.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '128', Library: 'd3-time-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2022 Mike Bostock'},
  {'#': '129', Library: 'd3-time-format-2.3.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2017 Mike Bostock'},
  {
    '#': '130',
    Library: 'd3-time-format-4.1.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2024 Mike Bostock and Observable, Inc.'
  },
  {'#': '131', Library: 'd3-timer-1.0.10.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {'#': '132', Library: 'd3-timer-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '133', Library: 'd3-transition-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '134', Library: 'd3-zoom-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {Copyrights: 'Copyright 2010-2021 Mike Bostock'},
  {'#': '135', Library: 'dayjs-1.11.10.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 iamkun'},
  {
    '#': '136',
    Library: 'debug-2.6.9.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {Copyrights: 'Copyright 2014-2016 TJ Holowaychuk <tj@vision-media.ca>'},
  {Copyrights: 'Copyright 2014-2016 TJ Holowaychuk'},
  {
    '#': '137',
    Library: 'debug-3.2.7.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {Copyrights: 'Copyright 2014-2017 TJ Holowaychuk <tj@vision-media.ca>'},
  {Copyrights: 'Copyright 2014-2017 TJ Holowaychuk'},
  {
    '#': '138',
    Library: 'decode-uri-component-0.2.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Sam Verschueren <sam.verschueren@gmail.com> (github.com/SamVerschueren)'
  },
  {'#': '139', Library: 'defined-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright James Halliday mail@substack.net'},
  {'#': '140', Library: 'delaunator-5.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2017 Mapbox'},
  {
    '#': '141',
    Library: 'dequal-2.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {
    '#': '142',
    Library: 'detect-kerning-2.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Dmitry Yv df.creative@gmail.com'
  },
  {'#': '143', Library: 'dfa-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Devon Govett devongovett@gmail.com'},
  {
    '#': '144',
    Library: 'diff-sequences-28.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '145', Library: 'dom-1.6.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '146', Library: 'dom-8.14.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Kent C. Dodds'},
  {
    '#': '147',
    Library: 'dom-accessibility-api-0.5.14.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2020 Sebastian Silbermann'
  },
  {'#': '148', Library: 'dom-helpers-5.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jason Quense'},
  {'#': '149', Library: 'draw-svg-path-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Michael Rhodes'},
  {'#': '150', Library: 'dtype-2.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Kyle Robinson Young'},
  {'#': '151', Library: 'dup-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Mikola Lysenko'},
  {'#': '152', Library: 'duplexify-3.7.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Mathias Buus'},
  {'#': '153', Library: 'earcut-2.2.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2016 Mapbox'},
  {Copyrights: 'Copyright 2016 Mapbox'},
  {'#': '154', Library: 'earcut-3.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2024 Mapbox'},
  {
    '#': '155',
    Library: 'element-resize-detector-1.2.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 Lucas Wiener'
  },
  {
    '#': '156',
    Library: 'element-size-1.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Hugh Kennedy hughskennedy@gmail.com'
  },
  {
    '#': '157',
    Library: 'elementary-circuits-directed-graph-1.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019 Antoine Roy-Gobeil'
  },
  {Copyrights: 'Copyright 2018 Antoine Roy-Gobeil'},
  {
    '#': '158',
    Library: 'emoji-regex-10.5.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Mathias Bynens <https://mathiasbynens.be/>'
  },
  {'#': '159', Library: 'end-of-stream-1.4.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Mathias Buus'},
  {'#': '160', Library: 'equality-0.5.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Ben Newman'},
  {Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'},
  {'#': '161', Library: 'error-ex-1.3.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '162', Library: 'es5-ext-0.10.64.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2011-2024 Mariusz Nowak'},
  {
    '#': '163',
    Library: 'es6-iterator-2.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013-2017 Mariusz Nowak (www.medikoo.com)'
  },
  {Copyrights: 'Copyright 2013-2017 Mariusz Nowak'},
  {'#': '164', Library: 'es6-symbol-3.1.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2013-2024 Mariusz Nowak'},
  {
    '#': '165',
    Library: 'es6-weak-map-2.0.3.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2013-2018 Mariusz Nowak, @medikoo, medikoo.com'
  },
  {
    '#': '166',
    Library: 'escape-string-regexp-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {
    '#': '167',
    Library: 'escodegen-2.1.0.tgz',
    Licenses: 'BSD 2',
    Copyrights: 'Copyright 2012 Yusuke Suzuki" (http://github.com/Constellation)'
  },
  {Copyrights: 'Copyright 2012 Yusuke Suzuki (twitter: @Constellation) and other contributors'},
  {Copyrights: 'Copyright 2012 Yusuke Suzuki" (http://github.com/Constellation)'},
  {Copyrights: 'Copyright 2012 Yusuke Suzuki (twitter: @Constellation) and other contributors'},
  {'#': '168', Library: 'esniff-2.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2013-2024 Mariusz Nowak'},
  {
    '#': '169',
    Library: 'esprima-4.0.1.tgz',
    Licenses: 'BSD 2',
    Copyrights: 'Copyright JS Foundation and other contributors, https://js.foundation/'
  },
  {'#': '170', Library: 'estraverse-5.3.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2012-2016 Yusuke Suzuki'},
  {
    '#': '171',
    Library: 'esutils-2.0.3.tgz',
    Licenses: 'BSD 2',
    Copyrights: 'Copyright 2013 [Yusuke Suzuki](http://github.com/Constellation)'
  },
  {Copyrights: 'Copyright 2013 "Yusuke Suzuki" (http://github.com/Constellation)'},
  {
    '#': '172',
    Library: 'event-emitter-0.3.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012-2015 Mariusz Nowak (www.medikoo.com)'
  },
  {Copyrights: 'Copyright 2012-2015 Mariusz Nowak'},
  {
    '#': '173',
    Library: 'events-3.3.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Joyent, Inc. and other Node contributors'
  },
  {Copyrights: 'Copyright Joyent, Inc. and other Node contributors'},
  {'#': '174', Library: 'ext-1.7.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2011-2022 Mariusz Nowak'},
  {Copyrights: 'Copyright 2011-2022 Mariusz Nowak'},
  {'#': '175', Library: 'falafel-2.2.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012 James Halliday'},
  {'#': '176', Library: 'fast-deep-equal-3.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Evgeny Poberezkin'},
  {Copyrights: 'Copyright 2017 Evgeny Poberezkin'},
  {'#': '177', Library: 'fast-isnumeric-1.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Alex Johnson'},
  {
    '#': '178',
    Library: 'file-saver-2.0.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 "Eli Grey" (http://eligrey.com)'
  },
  {'#': '179', Library: 'find-root-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 jsdnxx'},
  {Copyrights: 'Copyright 2017 jsdnxx'},
  {'#': '180', Library: 'findup-0.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Filirom1 filirom1@gmail.com'},
  {'#': '181', Library: 'flatten-vertex-data-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 glo-js'},
  {
    '#': '182',
    Library: 'fns-2.2.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {
    '#': '183',
    Library: 'font-2.5.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {
    '#': '184',
    Library: 'font-atlas-2.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Hugh Kennedy hughskennedy@gmail.com'
  },
  {'#': '185', Library: 'font-measure-1.2.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Dmitry Yv'},
  {'#': '186', Library: 'fontkit-2.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright -'},
  {'#': '187', Library: 'from2-2.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Hugh Kennedy'},
  {'#': '188', Library: 'function-bind-1.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Raynos'},
  {'#': '189', Library: 'geojson-7946.0.16.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '190', Library: 'geojson-rewind-0.5.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2020 Mapbox'},
  {'#': '191', Library: 'geojson-types-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Mapbox'},
  {'#': '192', Library: 'geojson-vt-3.2.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2015 Mapbox'},
  {'#': '193', Library: 'geojson-vt-3.2.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '194', Library: 'geojson-vt-4.0.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2015 Mapbox'},
  {'#': '195', Library: 'get-canvas-context-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jam3'},
  {
    '#': '196',
    Library: 'get-stream-6.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'},
  {
    '#': '197',
    Library: 'gl-mat4-1.2.0.tgz',
    Licenses: 'Zlib',
    Copyrights: 'Copyright 2013 Brandon Jones, Colin MacKenzie IV'
  },
  {'#': '198', Library: 'gl-matrix-3.4.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015-2021 Brandon Jones'},
  {'#': '199', Library: 'gl-text-1.4.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Dmitry Ivanov'},
  {Copyrights: 'Copyright 2018 Dmitry Yv'},
  {'#': '200', Library: 'gl-util-3.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Dmitry Yv'},
  {
    '#': '201',
    Library: 'global-prefix-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2018 Jon Schlinkert" (https://github.com/jonschlinkert)'
  },
  {Copyrights: 'Copyright 2015 Jon Schlinkert'},
  {
    '#': '202',
    Library: 'glsl-inject-defines-1.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'},
  {'#': '203', Library: 'glsl-resolve-0.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Hugh Kennedy'},
  {
    '#': '204',
    Library: 'glsl-token-assignments-2.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'},
  {
    '#': '205',
    Library: 'glsl-token-defines-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {
    '#': '206',
    Library: 'glsl-token-depth-1.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'},
  {
    '#': '207',
    Library: 'glsl-token-descope-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {'#': '208', Library: 'glsl-token-inject-block-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jam3'},
  {
    '#': '209',
    Library: 'glsl-token-properties-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'},
  {
    '#': '210',
    Library: 'glsl-token-scope-1.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'},
  {
    '#': '211',
    Library: 'glsl-token-string-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'},
  {
    '#': '212',
    Library: 'glsl-token-whitespace-trim-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2015 Hugh Kennedy'
  },
  {
    '#': '213',
    Library: 'glsl-tokenizer-2.1.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Chris Dickinson" (http://github.com/chrisdickinson)'
  },
  {'#': '214', Library: 'glslify-7.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2011 Ashima Arts'},
  {Copyrights: 'Copyright 2015 "stackgl" (http://github.com/stackgl/) contributors'},
  {Copyrights: 'Copyright 2015 "Chris Dickinson" (http://github.com/chrisdickinson)'},
  {
    '#': '215',
    Library: 'glslify-bundle-5.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 stackgl" (http://github.com/stackgl/) contributors'
  },
  {Copyrights: 'Copyright 2014 [stackgl](http://github.com/stackgl/) contributors'},
  {
    '#': '216',
    Library: 'glslify-deps-1.3.2.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright Hugh Kennedy hughskennedy@gmail.com (http://hughsk.io/)'
  },
  {
    '#': '217',
    Library: 'graceful-fs-4.2.11.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2011-2022 Isaac Z. Schlueter'
  },
  {'#': '218', Library: 'graphql-16.8.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright GraphQL Contributors'},
  {'#': '219', Library: 'graphql-tag-2.12.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Apollo Graph, Inc'},
  {'#': '220', Library: 'grid-index-1.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2016 Mapbox'},
  {
    '#': '221',
    Library: 'hammerjs-2.0.8.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011-2014 by Jorik Tangelder (Eight Media)'
  },
  {Copyrights: 'Copyright 2011-2014 by Jorik Tangelder'},
  {
    '#': '222',
    Library: 'has-flag-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '223',
    Library: 'has-hover-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2007 Free Software Foundation Inc.'
  },
  {'#': '224', Library: 'has-passive-events-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '225', Library: 'hash-0.8.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Emotion team and other contributors'},
  {Copyrights: 'Copyright 2016 Kye Hohenberger'},
  {'#': '226', Library: 'hasown-2.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Jordan Harband and contributors'},
  {
    '#': '227',
    Library: 'helper-module-imports-7.18.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '228',
    Library: 'helper-plugin-utils-7.18.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '229',
    Library: 'helper-string-parser-7.27.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '230',
    Library: 'helper-validator-identifier-7.27.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '231', Library: 'helpers-0.4.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright Contributor: kdy1'},
  {'#': '232', Library: 'helpers-0.4.36.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright -'},
  {'#': '233', Library: 'helpers-6.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 TurfJS'},
  {Copyrights: 'Copyright 2019 Morgan Herlocker'},
  {'#': '234', Library: 'hoist-non-react-statics-3.3.2.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2015 Yahoo!'},
  {
    '#': '235',
    Library: 'hoist-non-react-statics-3.3.7.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {'#': '236', Library: 'hsl-to-hex-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright David Mark Clements 2016'},
  {
    '#': '237',
    Library: 'hsl-to-rgb-for-reals-1.1.1.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright David Mark Clements 2019'
  },
  {
    '#': '238',
    Library: 'hsluv-0.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: '2012 Copyright (c)  Alexei Boronine  Florian Dormont'
  },
  {'#': '239', Library: 'html-to-image-1.11.11.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017-2023 W.Y'},
  {'#': '240', Library: 'husky-9.1.7.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 typicode'},
  {
    '#': '241',
    Library: 'hyphen-1.10.4.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2023 Yevhen Tiurin <yevhentiurin@gmail.com>'
  },
  {'#': '242', Library: 'icons-material-5.8.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '243', Library: 'iconv-lite-0.4.24.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2011 Alexander Shtuchkin'},
  {'#': '244', Library: 'iconv-lite-0.6.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2011 Alexander Shtuchkin'},
  {Copyrights: 'Copyright 2011 Alexander Shtuchkin'},
  {'#': '245', Library: 'ieee754-1.2.1.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2008 Fair Oaks Labs, Inc'},
  {Copyrights: 'Copyright 2008 Fair Oaks Labs, Inc'},
  {Copyrights: 'Copyright 2008 Fair Oaks Labs, Inc'},
  {Copyrights: 'Copyright 2008 Fair Oaks Labs, Inc'},
  {
    '#': '246',
    Library: 'image-2.3.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '247', Library: 'immer-10.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Michel Weststrate'},
  {Copyrights: 'Copyright 2017 Michel Weststrate'},
  {'#': '248', Library: 'immer-9.0.21.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Michel Weststrate'},
  {
    '#': '249',
    Library: 'import-fresh-3.3.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {
    '#': '250',
    Library: 'indent-string-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '251', Library: 'inherits-2.0.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z'},
  {'#': '252', Library: 'ini-4.1.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'},
  {'#': '253', Library: 'internmap-2.0.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021 Mike Bostock'},
  {'#': '254', Library: 'invariant-2.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Facebook, Inc'},
  {'#': '255', Library: 'is-arrayish-0.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '256', Library: 'is-arrayish-0.3.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '257', Library: 'is-browser-2.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Forbes Lindesay'},
  {'#': '258', Library: 'is-core-module-2.16.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Dave Justice'},
  {
    '#': '259',
    Library: 'is-finite-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {
    '#': '260',
    Library: 'is-firefox-1.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Andreas Gillström <andreasgillstrom@gmail.com> (github.com/gillstrom)'
  },
  {Copyrights: 'Copyright Andreas Gillstrom'},
  {
    '#': '261',
    Library: 'is-iexplorer-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Kevin Mårtensson <kevinmartensson@gmail.com>'
  },
  {Copyrights: 'Copyright Kevin Martensson'},
  {
    '#': '262',
    Library: 'is-mobile-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Julian Gruber <julian@juliangruber.com>'
  },
  {Copyrights: 'Copyright 2013 Julian Gruber "julian@juliangruber.com" (mailto:julian@juliangruber.com)'},
  {
    '#': '263',
    Library: 'is-obj-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '264',
    Library: 'is-plain-obj-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '265',
    Library: 'is-prop-valid-1.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '266', Library: 'is-string-blank-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Alex Johnson'},
  {'#': '267', Library: 'is-svg-path-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 sindresorhus.com'},
  {'#': '268', Library: 'is-url-1.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright segment.com 2018'},
  {
    '#': '269',
    Library: 'isarray-0.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Julian Gruber <julian@juliangruber.com>'
  },
  {
    '#': '270',
    Library: 'isarray-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Julian Gruber <julian@juliangruber.com>'
  },
  {
    '#': '271',
    Library: 'isarray-2.0.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Julian Gruber <julian@juliangruber.com>'
  },
  {
    '#': '272',
    Library: 'isexe-3.1.1.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2016-2022 Isaac Z. Schlueter and Contributors'
  },
  {
    '#': '273',
    Library: 'jay-peg-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '274', Library: 'jest-28.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '275',
    Library: 'jest-diff-28.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '276', Library: 'jest-dom-5.16.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Kent C. Dodds'},
  {
    '#': '277',
    Library: 'jest-get-type-28.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '278',
    Library: 'jest-matcher-utils-28.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '279', Library: 'js-base64-3.7.7.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2014 Dan Kogai'},
  {
    '#': '280',
    Library: 'js-tokens-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2015 2016, 2017, 2018 Simon Lydell'
  },
  {Copyrights: 'Copyright 2014-2018 Simon Lydell'},
  {
    '#': '281',
    Library: 'json-parse-even-better-errors-2.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Kat Marchán'
  },
  {Copyrights: 'Copyright npm, Inc'},
  {
    '#': '282',
    Library: 'json-stringify-pretty-compact-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2022 Simon Lydell'
  },
  {
    '#': '283',
    Library: 'jsonlint-lines-primitives-2.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Zach Carter zach@carter.name'
  },
  {'#': '284', Library: 'kdbush-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Vladimir Agafonkin'},
  {'#': '285', Library: 'kdbush-4.0.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Vladimir Agafonkin'},
  {
    '#': '286',
    Library: 'kind-of-6.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2020 [Jon Schlinkert](https://github.com/jonschlinkert)'
  },
  {Copyrights: 'Copyright 2014-2017 Jon Schlinkert'},
  {Copyrights: 'Copyright 2020 "Jon Schlinkert" (https://github.com/jonschlinkert)'},
  {
    '#': '287',
    Library: 'layout-3.11.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '288', Library: 'lines-and-columns-1.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Brian Donovan'},
  {
    '#': '289',
    Library: 'lodash-4.18.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright OpenJS Foundation and other contributors <https://openjsf.org/>'
  },
  {
    '#': '290',
    Library: 'lodash.merge-4.6.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright OpenJS Foundation and other contributors <https://openjsf.org/>'
  },
  {
    '#': '291',
    Library: 'loose-envify-1.4.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2015 Andres Suarez <zertosh@gmail.com>'
  },
  {
    '#': '292',
    Library: 'lz-string-1.4.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2004 Sam Hocevar <sam@hocevar.net>'
  },
  {'#': '293', Library: 'map-limit-0.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Hugh Kennedy'},
  {'#': '294', Library: 'mapbox-gl-1.13.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2011 by Evan Wallace'},
  {Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {Copyrights: 'Copyright 2020 Mapbox'},
  {'#': '295', Library: 'mapbox-gl-supported-1.5.0.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2017 Mapbox'},
  {
    '#': '296',
    Library: 'mapbox__point-geometry-0.1.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '297',
    Library: 'mapbox__vector-tile-1.3.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {'#': '298', Library: 'maplibre-gl-5.2.0.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2020 Mapbox'},
  {Copyrights: 'Copyright 2023 MapLibre contributors'},
  {Copyrights: 'Copyright 2010-2016 Mike Bostock'},
  {Copyrights: 'Copyright 2011 by Evan Wallace'},
  {
    '#': '299',
    Library: 'maplibre-gl-style-spec-23.1.0.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2010-2016 Mike Bostock'
  },
  {Copyrights: 'Copyright 2011 by Evan Wallace'},
  {Copyrights: 'Copyright 2020 Mapbox'},
  {Copyrights: 'Copyright 2020 MapLibre contributors'},
  {'#': '300', Library: 'material-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '301',
    Library: 'math-log2-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '302', Library: 'media-engine-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole 2018'},
  {
    '#': '303',
    Library: 'memoize-0.7.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {
    '#': '304',
    Library: 'memoize-0.8.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright 2016 Kye Hohenberger'},
  {'#': '305', Library: 'meta-6.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 TurfJS'},
  {Copyrights: 'Copyright 2019 Morgan Herlocker'},
  {
    '#': '306',
    Library: 'min-indent-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com), James Kyle <me@thejam'
  },
  {'#': '307', Library: 'minimist-1.2.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright James Haliday'},
  {'#': '308', Library: 'mouse-change-1.4.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Mikola Lysenko'},
  {'#': '309', Library: 'mouse-event-1.0.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Mikola Lysenko'},
  {'#': '310', Library: 'mouse-event-offset-3.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Matt DesLauriers'},
  {'#': '311', Library: 'mouse-wheel-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Mikola Lysenko'},
  {'#': '312', Library: 'ms-2.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Zeit, Inc'},
  {'#': '313', Library: 'ms-2.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Zeit, Inc'},
  {'#': '314', Library: 'msal-browser-2.26.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '315', Library: 'msal-common-7.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '316', Library: 'msal-react-1.4.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '317', Library: 'mumath-3.3.4.tgz', Licenses: 'Unlicense', Copyrights: 'Copyright dfcreative'},
  {'#': '318', Library: 'murmurhash-js-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2011 Gary Court'},
  {'#': '319', Library: 'native-promise-only-0.8.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Kyle Simpson'},
  {'#': '320', Library: 'needle-2.9.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Fork, Ltd'},
  {
    '#': '321',
    Library: 'next-tick-1.1.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2012-2020 Mariusz Nowak, @medikoo, medikoo.com'
  },
  {Copyrights: 'Copyright 2012-2020 Mariusz Nowak, @medikoo, medikoo.com'},
  {'#': '322', Library: 'node-fetch-2.7.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 David Frank'},
  {
    '#': '323',
    Library: 'normalize-svg-path-0.1.0.tgz',
    Licenses: 'MIT',
    Copyrights:
      '2008 Copyright © Dmitry Baranovskiy http://raphaeljs.com, Sencha Labs http://sencha.com, Jake Rosoman jkroso@gmail.com'
  },
  {
    '#': '324',
    Library: 'normalize-svg-path-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2008-2013 Dmitry Baranovskiy'
  },
  {Copyrights: 'Copyright 2013 Jake Rosoman "jkroso@gmail.com" (mailto:jkroso@gmail.com)'},
  {Copyrights: 'Copyright 2008-2013 Sencha Labs'},
  {
    '#': '325',
    Library: 'number-is-integer-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '326',
    Library: 'object-assign-4.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '327', Library: 'once-1.3.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'},
  {'#': '328', Library: 'once-1.4.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'},
  {'#': '329', Library: 'optimism-0.16.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Ben Newman'},
  {Copyrights: 'Copyright 2016 Ben Newman'},
  {'#': '330', Library: 'pako-0.2.9.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014-2016 by Vitaly Puzrin'},
  {
    '#': '331',
    Library: 'pako-1.0.11.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2017 by Vitaly Puzrin and Andrei Tuputcyn'
  },
  {
    '#': '332',
    Library: 'parent-module-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '333', Library: 'parenthesis-3.1.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Dmitry Ivanov'},
  {'#': '334', Library: 'parse-json-4.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '335',
    Library: 'parse-json-5.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {'#': '336', Library: 'parse-rect-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Dmitry Yv'},
  {Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {
    '#': '337',
    Library: 'parse-svg-path-0.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Jake Rosoman <jkroso@gmail.com>'
  },
  {'#': '338', Library: 'parse-unit-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Matt DesLauriers'},
  {'#': '339', Library: 'path-parse-1.0.7.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Javier Blanco'},
  {
    '#': '340',
    Library: 'path-type-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '341', Library: 'pbf-3.0.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '342', Library: 'pbf-3.3.0.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2017 Mapbox'},
  {'#': '343', Library: 'pdfkit-3.1.10.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Devon Govett'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {'#': '344', Library: 'performance-now-2.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Braveg1rl'},
  {Copyrights: 'Copyright 2013 Braveg1rl'},
  {'#': '345', Library: 'pick-by-alias-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {'#': '346', Library: 'picocolors-1.1.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021-2024 Oleksii Raspopov'},
  {'#': '347', Library: 'plotly.js-2.34.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Plotly, Inc'},
  {Copyrights: 'Copyright and license" (#copyright-and-license)'},
  {Copyrights: 'Copyright 2021 Plotly, Inc'},
  {'#': '348', Library: 'plotly.js-dist-2.34.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Plotly, Inc'},
  {Copyrights: 'Copyright and license'},
  {Copyrights: 'Copyright 2024 Plotly, Inc'},
  {
    '#': '349',
    Library: 'plugin-syntax-jsx-7.18.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '350', Library: 'png-js-2.3.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Devon Govett'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {'#': '351', Library: 'point-cluster-3.1.9.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '352', Library: 'point-geometry-0.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2015 Mapbox <>'},
  {'#': '353', Library: 'point-in-polygon-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 James Halliday'},
  {Copyrights: 'Copyright 2016 James Halliday'},
  {
    '#': '354',
    Library: 'polybooljs-1.2.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 Sean Connelly (@voidqk, web: syntheti.cc)'
  },
  {
    '#': '355',
    Library: 'postcss-value-parser-4.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Bogdan Chadkin <trysound@yandex.ru>'
  },
  {Copyrights: 'Copyright Bogdan Chadkin <trysound@yandex.ru>'},
  {'#': '356', Library: 'potpack-1.0.2.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Mapbox'},
  {'#': '357', Library: 'potpack-2.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Mapbox'},
  {'#': '358', Library: 'prettier-2.7.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012-2017 by Ingvar Stepanyan'},
  {Copyrights: 'Copyright 2009-2015 Kevin Decker <kpdecker@gmail.com>'},
  {Copyrights: 'Copyright 2013 James Halliday (mail@substack.net)'},
  {Copyrights: 'Copyright 2015 JD Ballard'},
  {Copyrights: 'Copyright 2012-2014 by various contributors'},
  {Copyrights: 'Copyright 2017 Martin Muñoz and contributors'},
  {Copyrights: 'Copyright 2015 Tilde, Inc'},
  {Copyrights: 'Copyright 2011-2016 Heather Arthur <fayearthur@gmail.com>'},
  {Copyrights: 'Copyright 2018-2021 Josh Junon'},
  {Copyrights: 'Copyright 2012-2020 by various contributors'},
  {Copyrights: 'Copyright 2012 EditorConfig Team'},
  {Copyrights: 'Copyright 2011-2015 Paul Vorbach <paul@vorba.ch>'},
  {Copyrights: 'Copyright James Long and contributors'},
  {Copyrights: 'Copyright 2019 TypeScript ESLint and other contributors'},
  {Copyrights: 'Copyright 2014 Jon Schlinkert'},
  {Copyrights: 'Copyright 2015 Elijah Insua'},
  {Copyrights: 'Copyright 2013 Julian Gruber <julian@juliangruber.com>'},
  {Copyrights: 'Copyright 2014-2018 Jon Schlinkert'},
  {Copyrights: 'Copyright 2015 David Clark'},
  {Copyrights: 'Copyright 2014 Stefan Thomas'},
  {Copyrights: 'Copyright 2013 James Halliday'},
  {Copyrights: 'Copyright 2015-2020 Matteo Collina <matteo.collina@gmail.com>'},
  {Copyrights: 'Copyright 2015 Roy Riojas'},
  {Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'},
  {Copyrights: 'Copyright 2013 Thorsten Lorenz'},
  {Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {Copyrights: 'Copyright 2017 Evgeny Poberezkin'},
  {Copyrights: 'Copyright 2018 Made With MOXY Lda <hello@moxy.studio>'},
  {Copyrights: 'Copyright 2015 Jon Schlinkert'},
  {Copyrights: 'Copyright 2016-2021 Thomas Watson Steen'},
  {Copyrights: 'Copyright 2016 Rebecca Turner <me@re-becca.org>'},
  {Copyrights: 'Copyright 2015 Titus Wormer <tituswormer@gmail.com>'},
  {Copyrights: 'Copyright 2014-2017 TJ Holowaychuk <tj@vision-media.ca>'},
  {
    '#': '359',
    Library: 'pretty-format-27.5.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '360',
    Library: 'pretty-format-28.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {
    '#': '361',
    Library: 'pretty-format-28.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {
    '#': '362',
    Library: 'primitives-3.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '363', Library: 'private-theming-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '364', Library: 'probe-image-size-7.2.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Vitaly Puzrin'},
  {Copyrights: 'Copyright 2015 Vitaly Puzrin'},
  {'#': '365', Library: 'process-nextick-args-2.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Calvin Metcalf'},
  {'#': '366', Library: 'prop-types-15.7.12.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '367', Library: 'prop-types-15.8.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Facebook, Inc'},
  {Copyrights: 'Copyright 2013 Facebook, Inc'},
  {
    '#': '368',
    Library: 'protocol-buffers-schema-3.6.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Mathias Buus'
  },
  {
    '#': '369',
    Library: 'queue-6.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Jesse Tane <jesse.tane@gmail.com>'
  },
  {Copyrights: 'Copyright 2014 Jesse Tane "jesse.tane@gmail.com" (mailto:jesse.tane@gmail.com)'},
  {Copyrights: 'Copyright 2014 Jesse Tane <jesse.tane@gmail.com>'},
  {Copyrights: 'Copyright 2014 Jesse Tane "jesse.tane@gmail.com" (mailto:jesse.tane@gmail.com)'},
  {
    '#': '370',
    Library: 'quick-lru-7.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {'#': '371', Library: 'quickselect-2.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Vladimir Agafonkin'},
  {'#': '372', Library: 'quickselect-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2024 Vladimir Agafonkin'},
  {
    '#': '373',
    Library: 'raf-3.4.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Chris Dickinson <chris@neversaw.us>'
  },
  {
    '#': '374',
    Library: 'react-11.9.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '375', Library: 'react-13.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Kent C. Dodds'},
  {Copyrights: 'Copyright 2017 Kent C. Dodds'},
  {'#': '376', Library: 'react-18.0.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '377', Library: 'react-18.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '378', Library: 'react-chartjs-2-5.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Jeremy Ayerst'},
  {Copyrights: 'Copyright 2017 Jeremy Ayerst'},
  {Copyrights: 'Copyright 2020 Jeremy Ayerst'},
  {'#': '379', Library: 'react-csv-2.2.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 react-csv'},
  {Copyrights: 'Copyright 2019 react-csv'},
  {'#': '380', Library: 'react-dom-18.0.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '381',
    Library: 'react-dom-18.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {'#': '382', Library: 'react-dom-2.0.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '383', Library: 'react-draggable-4.4.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014-2016 Matt Zabriskie'},
  {
    '#': '384',
    Library: 'react-is-16.13.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '385',
    Library: 'react-is-17.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '386',
    Library: 'react-is-18.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '387',
    Library: 'react-is-18.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {'#': '388', Library: 'react-plotly.js-2.6.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Plotly, Inc'},
  {'#': '389', Library: 'react-redux-8.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {'#': '390', Library: 'react-resizable-layout-0.7.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2022 Ryo Sogawa'},
  {
    '#': '391',
    Library: 'react-router-6.30.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2015-2019 React Training LLC'
  },
  {Copyrights: 'Copyright 2022-2023 Shopify Inc'},
  {Copyrights: 'Copyright 2020-2021 Remix Software Inc'},
  {
    '#': '392',
    Library: 'react-router-dom-6.30.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2020-2021 Remix Software Inc'
  },
  {Copyrights: 'Copyright 2022-2023 Shopify Inc'},
  {Copyrights: 'Copyright 2015-2019 React Training LLC'},
  {'#': '393', Library: 'react-sizeme-3.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Sean Matheson'},
  {Copyrights: 'Copyright 2016 Sean Matheson'},
  {
    '#': '394',
    Library: 'react-transition-group-4.4.10.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '395',
    Library: 'react-transition-group-4.4.5.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2013 Facebook, Inc'
  },
  {Copyrights: 'Copyright 2018 React Community'},
  {Copyrights: 'Copyright 2018 React Community'},
  {Copyrights: 'Copyright 2013 Facebook, Inc'},
  {'#': '396', Library: 'react-virtuoso-4.6.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Petyo Ivanov'},
  {
    '#': '397',
    Library: 'readable-stream-1.0.34.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Joyent, Inc. and other Node contributors'
  },
  {'#': '398', Library: 'readable-stream-2.3.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright Node.js contributors'},
  {Copyrights: 'Copyright Node.js contributors'},
  {
    '#': '399',
    Library: 'redent-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '400', Library: 'redux-5.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {'#': '401', Library: 'redux-thunk-3.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {'#': '402', Library: 'regl-2.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 MIT License'},
  {Copyrights: 'Copyright 2016 Mikola Lysenko'},
  {'#': '403', Library: 'regl-error2d-2.0.12.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '404', Library: 'regl-line2d-3.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '405', Library: 'regl-scatter2d-3.3.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '406', Library: 'regl-splom-1.0.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Dmitry Ivanov'},
  {'#': '407', Library: 'render-3.4.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {'#': '408', Library: 'renderer-3.4.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {
    '#': '409',
    Library: 'require-from-string-2.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Vsevolod Strukchinsky <floatdrop@gmail.com> (github.com/floatdrop)'
  },
  {Copyrights: 'Copyright Vsevolod Strukchinsky'},
  {'#': '410', Library: 'reselect-5.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015-2018 Reselect Contributors'},
  {'#': '411', Library: 'resolve-0.6.3.tgz', Licenses: 'MIT', Copyrights: '2012 Copyright (c)  James Halliday'},
  {'#': '412', Library: 'resolve-1.22.11.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012 James Halliday'},
  {
    '#': '413',
    Library: 'resolve-from-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '414',
    Library: 'resolve-protobuf-schema-2.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Mathias Buus'
  },
  {'#': '415', Library: 'restructure-3.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Devon Govett'},
  {Copyrights: 'Copyright 2015 Devon Govett'},
  {
    '#': '416',
    Library: 'right-now-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Hugh Kennedy hughskennedy@gmail.com (http://hughskennedy.com'
  },
  {
    '#': '417',
    Library: 'robust-predicates-3.0.1.tgz',
    Licenses: 'Unlicense',
    Copyrights: 'Copyright Vladimir Agafonkin (Unlicence)'
  },
  {'#': '418', Library: 'router-1.23.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2022-2023 Shopify Inc'},
  {Copyrights: 'Copyright 2020-2021 Remix Software Inc'},
  {Copyrights: 'Copyright 2015-2019 React Training LLC'},
  {
    '#': '419',
    Library: 'runtime-7.27.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '420', Library: 'rw-1.3.3.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2014-2016 Michael Bostock'},
  {'#': '421', Library: 'safe-buffer-5.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Feross Aboukhadijeh'},
  {Copyrights: 'Copyright Feross Aboukhadijeh" (http://feross.org)'},
  {'#': '422', Library: 'safe-buffer-5.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Feross Aboukhadijeh'},
  {Copyrights: 'Copyright Feross Aboukhadijeh'},
  {
    '#': '423',
    Library: 'safer-buffer-2.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2018 Nikita Skovoroda <chalkerx@gmail.com>'
  },
  {'#': '424', Library: 'sax-1.2.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z'},
  {Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'},
  {'#': '425', Library: 'scheduler-0.16.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '426',
    Library: 'scheduler-0.17.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '427',
    Library: 'scheduler-0.23.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '428',
    Library: 'schemas-28.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '429', Library: 'sdk-3.0.2.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2022 MapTiler'},
  {
    '#': '430',
    Library: 'serialize-1.0.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright 2016 Kye Hohenberger'},
  {
    '#': '431',
    Library: 'shallow-copy-0.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright James Halliday mail@substack.net'
  },
  {
    '#': '432',
    Library: 'shallowequal-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Alberto Leal <mailforalberto@gmail.com> (github.com/dashed)'
  },
  {
    '#': '433',
    Library: 'sheet-1.2.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '434', Library: 'signum-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Mikola Lysenko'},
  {Copyrights: 'Copyright 2014 Mikola Lysenko'},
  {'#': '435', Library: 'simple-swizzle-0.2.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Josh Junon'},
  {
    '#': '436',
    Library: 'source-map-0.5.7.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2009-2011 Mozilla Foundation and contributors'
  },
  {
    '#': '437',
    Library: 'source-map-0.6.1.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2009-2011 Mozilla Foundation and contributors'
  },
  {'#': '438', Library: 'source-map-resolve-0.6.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 ZHAO Jinxiang'},
  {Copyrights: 'Copyright 2014-2015 2016, 2017, 2018, 2019, 2020 Simon Lydell'},
  {Copyrights: 'Copyright 2014-2015 2016, 2017, 2018, 2019, 2020 Simon Lydell'},
  {Copyrights: 'Copyright 2019 ZHAO Jinxiang'},
  {'#': '439', Library: 'spec-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Colin McDonnell'},
  {
    '#': '440',
    Library: 'stack-trace-0.0.9.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011 Felix Geisendörfer (felix@debuggable.com)'
  },
  {'#': '441', Library: 'static-eval-2.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 James Halliday'},
  {
    '#': '442',
    Library: 'stream-parser-0.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Nathan Rajlich <nathan@tootallnate.net>'
  },
  {'#': '443', Library: 'stream-shift-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Mathias Buus'},
  {
    '#': '444',
    Library: 'string-split-by-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Dmitry Yv dfcreative@gmail.com'
  },
  {
    '#': '445',
    Library: 'string_decoder-0.10.31.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Joyent, Inc. and other Node contributors'
  },
  {'#': '446', Library: 'string_decoder-1.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Node.js contributors'},
  {'#': '447', Library: 'string_decoder-1.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Node.js contributors'},
  {
    '#': '448',
    Library: 'strip-indent-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '449',
    Library: 'strongly-connected-components-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Mikola Lysenko'
  },
  {
    '#': '450',
    Library: 'styled-11.9.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '451', Library: 'styled-engine-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '452', Library: 'stylesheet-4.2.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {'#': '453', Library: 'stylis-4.0.13.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Sultan Tarimo'},
  {'#': '454', Library: 'stylis-4.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Sultan Tarimo'},
  {'#': '455', Library: 'supercluster-7.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '456', Library: 'supercluster-7.1.5.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021 Mapbox'},
  {'#': '457', Library: 'supercluster-8.0.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021 Mapbox'},
  {'#': '458', Library: 'superscript-text-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Mikola Lysenko'},
  {
    '#': '459',
    Library: 'supports-color-7.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {
    '#': '460',
    Library: 'supports-preserve-symlinks-flag-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2022 Inspect JS'
  },
  {
    '#': '461',
    Library: 'svg-arc-to-cubic-bezier-3.2.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2017 `Colin Meinke`'
  },
  {Copyrights: 'Copyright 2017 "Colin Meinke"'},
  {'#': '462', Library: 'svg-path-bounds-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Dima Yv'},
  {'#': '463', Library: 'svg-path-sdf-1.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dima Yv'},
  {
    '#': '464',
    Library: 'symbol-observable-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2021 Ben Lesh <ben@benlesh.com>'
  },
  {Copyrights: 'Copyright 2021 Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {'#': '465', Library: 'system-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '466',
    Library: 'testing-library__jest-dom-5.14.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '467',
    Library: 'textkit-4.4.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {
    '#': '468',
    Library: 'throttle-debounce-3.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2010 Ivan Nikolić and "Cowboy" Ben Alman'
  },
  {
    '#': '469',
    Library: 'through2-0.6.5.tgz',
    Licenses: 'MIT',
    Copyrights: '2026 Copyright 2013 Rod Vagg (the "Original Author")'
  },
  {
    '#': '470',
    Library: 'through2-2.0.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Rod Vagg (the "Original Author") and additional contributors'
  },
  {'#': '471', Library: 'tiny-inflate-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Devon Govett'},
  {'#': '472', Library: 'tiny-sdf-1.2.5.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2016-2021 Mapbox, Inc'},
  {Copyrights: 'Copyright 2016-2021 Mapbox, Inc'},
  {'#': '473', Library: 'tiny-sdf-2.0.6.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2016-2022 Mapbox, Inc'},
  {
    '#': '474',
    Library: 'tinycolor2-1.6.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright (c), Brian Grinstead, http://briangrinstead.com'
  },
  {Copyrights: 'Copyright (c), Brian Grinstead, http://briangrinstead.com'},
  {'#': '475', Library: 'tinyqueue-2.0.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2017 Vladimir Agafonkin'},
  {'#': '476', Library: 'tinyqueue-3.0.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2017 Vladimir Agafonkin'},
  {'#': '477', Library: 'to-float32-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Dmitry Yv'},
  {Copyrights: 'Copyright 2017 Dmitry Ivanov'},
  {'#': '478', Library: 'to-px-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Mikola Lysenko'},
  {'#': '479', Library: 'toolkit-2.9.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Mark Erikson'},
  {
    '#': '480',
    Library: 'topojson-client-3.1.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2012-2019 Michael Bostock'
  },
  {'#': '481', Library: 'tr46-0.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Sebastian Mayr'},
  {
    '#': '482',
    Library: 'trie-0.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'
  },
  {Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'},
  {'#': '483', Library: 'ts-invariant-0.10.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Apollo GraphQL'},
  {'#': '484', Library: 'tslib-2.8.1.tgz', Licenses: 'BSD Zero', Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '485', Library: 'type-2.7.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2019-2024 Mariusz Nowak'},
  {
    '#': '486',
    Library: 'typebox-0.24.28.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2022 Haydn Paterson (sinclair) <haydn.developer@gmail.com>'
  },
  {'#': '487', Library: 'typedarray-0.0.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012 Joshua Bell'},
  {Copyrights: 'Copyright 2010 Linden Research, Inc'},
  {'#': '488', Library: 'typedarray-pool-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Mikola Lysenko'},
  {Copyrights: 'Copyright 2014 Mikola Lysenko'},
  {
    '#': '489',
    Library: 'types-2.5.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '490', Library: 'types-7.2.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '491',
    Library: 'types-7.27.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '492', Library: 'unicode-properties-1.4.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018'},
  {'#': '493', Library: 'unicode-trie-2.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018'},
  {'#': '494', Library: 'unitbezier-0.0.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2008 Apple Inc.'},
  {'#': '495', Library: 'unitbezier-0.0.1.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2008 Apple Inc'},
  {
    '#': '496',
    Library: 'unitless-0.7.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '497', Library: 'unquote-1.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Cameron Lakenen'},
  {Copyrights: 'Copyright 2017 Cameron Lakenen'},
  {
    '#': '498',
    Library: 'update-diff-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Dima Yv df.creative@gmail.com'
  },
  {
    '#': '499',
    Library: 'use-deep-compare-effect-1.8.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2020 Kent C. Dodds'
  },
  {'#': '500', Library: 'use-immer-0.7.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Michel Weststrate'},
  {'#': '501', Library: 'use-supercluster-0.4.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Leigh Halliday'},
  {
    '#': '502',
    Library: 'use-sync-external-store-0.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '503',
    Library: 'use-sync-external-store-1.5.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Meta Platforms, Inc. and affiliates'
  },
  {'#': '504', Library: 'user-event-13.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Giorgio Polvara'},
  {
    '#': '505',
    Library: 'util-deprecate-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Nathan Rajlich <nathan@tootallnate.net>'
  },
  {Copyrights: 'Copyright 2014 Nathan Rajlich "nathan@tootallnate.net" (mailto:nathan@tootallnate.net)'},
  {'#': '506', Library: 'utils-0.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '507', Library: 'utils-0.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Fabian Hiller'},
  {
    '#': '508',
    Library: 'utils-1.2.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '509', Library: 'utils-5.15.14.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '510',
    Library: 'uuid-14.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2010-2020 Robert Kieffer and other contributors'
  },
  {'#': '511', Library: 'vector-tile-1.3.1.tgz', Licenses: 'BSD 3', Copyrights: 'Copyright 2014 Mapbox'},
  {
    '#': '512',
    Library: 'vite-compatible-readable-stream-3.6.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Node.js contributors'
  },
  {
    '#': '513',
    Library: 'vt-pbf-3.1.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Anand Thakker vestibule@anandthakker.net'
  },
  {
    '#': '514',
    Library: 'weak-map-1.0.8.tgz',
    Licenses: 'Apache 2.0',
    Copyrights: 'Copyright author=Mark Miller erights@gmail.com'
  },
  {
    '#': '515',
    Library: 'weak-memoize-0.2.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {
    '#': '516',
    Library: 'weak-memoize-0.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '517', Library: 'web-vitals-2.1.4.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2020 Google LLC'},
  {'#': '518', Library: 'webgl-context-2.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Matt DesLauriers'},
  {
    '#': '519',
    Library: 'webidl-conversions-3.0.1.tgz',
    Licenses: 'BSD 2',
    Copyrights: 'Copyright 2014 Domenic Denicola'
  },
  {'#': '520', Library: 'whatwg-url-5.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015-2016 Sebastian Mayr'},
  {Copyrights: 'Copyright 2015-2016 Sebastian Mayr'},
  {
    '#': '521',
    Library: 'which-4.0.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'
  },
  {'#': '522', Library: 'whoots-js-3.1.0.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2017 Mapbox'},
  {'#': '523', Library: 'world-calendars-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 alexcjohnson'},
  {
    '#': '524',
    Library: 'wrappy-1.0.2.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright Isaac Z. Schlueter and Contributors'
  },
  {'#': '525', Library: 'x-date-pickers-7.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Material-UI SAS'},
  {'#': '526', Library: 'xtend-2.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012 Raynos'},
  {'#': '527', Library: 'xtend-4.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012-2014 Raynos'},
  {'#': '528', Library: 'yaml-1.10.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2018 Eemeli Aro <eemeli@gmail.com>'},
  {
    '#': '529',
    Library: 'yoga-layout-2.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '530',
    Library: 'zen-observable-0.8.15.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2018 zenparsing (Kevin Smith)'
  },
  {Copyrights: 'Copyright 2018 zenparsing (Kevin Smith)'},
  {'#': '531', Library: 'zen-observable-ts-1.2.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Apollo Graph, Inc'}
]
